module.exports = __webpack_public_path__ + "fa99402d97f4f64e95f928a3108a05cc.pdf";